export const loaderContainerStyles = `
  absolute inset-0 w-full h-full
  flex items-center justify-center
  bg-gray-100 rounded-2xl z-10
`
